import { Styles, generateClasses } from 'netline-ui';
import getAppFrameTheme from 'utils/theme';

export const appHeaderRightClasses = generateClasses('AppHeaderRight', ['root', 'iconButton', 'parcel'] as const);

const styles: Styles = ({ theme }) => {
  const {
    appHeader: {
      text: { defaultTextColor },
      iconColor,
      elementHoverBackgroundColor,
    },
  } = getAppFrameTheme(theme);

  return {
    [`&.${appHeaderRightClasses.root}`]: {
      display: 'flex',
      alignItems: 'center',
      alignSelf: 'stretch',
      fontWeight: 500,
      color: defaultTextColor,
    },

    [`.${appHeaderRightClasses.iconButton}`]: {
      borderRadius: 0,
      color: iconColor,

      '&:hover': {
        background: elementHoverBackgroundColor,
      },
    },
  };
};
export default styles;
